import React from 'react';
import { Layout } from '../components/Layout';
import { Container } from '../components/ui/Container';
import { Card } from '../components/ui/Card';
import { Shield, Users, Lightbulb } from 'lucide-react';
export function AboutPage() {
  return <Layout data-id="element-162">
      <div className="bg-slate-50 py-16 border-b border-slate-200" data-id="element-163">
        <Container className="text-center" data-id="element-164">
          <h1 className="text-4xl font-bold text-slate-900 mb-6" data-id="element-165">
            About Brixen Credit
          </h1>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto" data-id="element-166">
            We are on a mission to demystify credit and empower individuals with
            the knowledge they need to achieve financial freedom.
          </p>
        </Container>
      </div>

      <Container className="py-20" data-id="element-167">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center mb-20" data-id="element-168">
          <div data-id="element-169">
            <h2 className="text-3xl font-bold text-slate-900 mb-6" data-id="element-170">
              Our Mission
            </h2>
            <p className="text-lg text-slate-600 mb-6 leading-relaxed" data-id="element-171">
              At Brixen Credit, we believe that financial literacy is the key to
              opportunity. Too many people are held back by a lack of
              understanding of how the credit system works.
            </p>
            <p className="text-lg text-slate-600 mb-6 leading-relaxed" data-id="element-172">
              We founded Brixen Credit to provide a transparent, ethical
              alternative to the "credit repair" industry. Instead of making
              empty promises about erasing debt, we focus on education,
              strategy, and responsible habit building.
            </p>
            <p className="text-lg text-slate-600 leading-relaxed" data-id="element-173">
              Our goal is not just to improve a score temporarily, but to give
              our clients the tools to maintain financial health for a lifetime.
            </p>
          </div>
          <div className="relative" data-id="element-174">
            <div className="absolute inset-0 bg-blue-600 rounded-2xl transform rotate-3 opacity-10" data-id="element-175"></div>
            <img src="https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="Team meeting" className="relative rounded-2xl shadow-lg w-full h-auto object-cover" data-id="element-176" />
          </div>
        </div>

        <div className="mb-20" data-id="element-177">
          <h2 className="text-3xl font-bold text-slate-900 mb-12 text-center" data-id="element-178">
            Our Core Values
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-179">
            <Card className="p-8 text-center hover:shadow-md transition-shadow" data-id="element-180">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-181">
                <Shield className="h-8 w-8 text-blue-600" data-id="element-182" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-183">
                Transparency
              </h3>
              <p className="text-slate-600" data-id="element-184">
                We are open about what we can and cannot do. We never make
                guarantees we can't keep and always explain our process clearly.
              </p>
            </Card>
            <Card className="p-8 text-center hover:shadow-md transition-shadow" data-id="element-185">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-186">
                <Lightbulb className="h-8 w-8 text-blue-600" data-id="element-187" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-188">
                Education First
              </h3>
              <p className="text-slate-600" data-id="element-189">
                We don't just fix problems; we teach you how to avoid them. Our
                success is measured by your understanding.
              </p>
            </Card>
            <Card className="p-8 text-center hover:shadow-md transition-shadow" data-id="element-190">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-191">
                <Users className="h-8 w-8 text-blue-600" data-id="element-192" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-193">
                Client Focused
              </h3>
              <p className="text-slate-600" data-id="element-194">
                Every financial situation is unique. We provide personalized
                strategies, not cookie-cutter solutions.
              </p>
            </Card>
          </div>
        </div>
      </Container>
    </Layout>;
}